import { BaseService, Service } from "/@/cool";
@Service("wlOrderDetails")
class WlOrderDetails extends BaseService {}
export default WlOrderDetails;
